import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nq6jhdeet: FaireProductEntity = {
  token: "p_5nq6jhdeet",
  type: "product",
  name: "In My Thoughts Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/25c6b1ee5d29a64fcbf3e5832a01c9ab0068cdb155a00a5e25b21839603cf798.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e258fca2dd34e0c073bbda6d17915fc023949974840c368ebb5406fe19fb566.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:24.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
